import React from 'react';
import './StyleComponents/HomeTechnicalSkills.css';

const HomeTechnicalSkills = () => {
    return (
        <section className="SmileWrapper" id='smile'>
            <h1 className="SmileHeader">Her Smile ✧</h1>

            <div className="HomeTechnicalSkillsContainer">
                <p>
                    Your smile does something to me.
                    It slows the world down,
                    and make feels exactly where it should be.
                </p>

                <p>
                    It’s warm without asking,
                    soft without trying,
                    and somehow powerful enough
                    to stay with me long after it’s gone.
                </p>
            </div>
        </section>
    );
};

export default HomeTechnicalSkills;
